// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"8ebbfaaa","225":"8ebbfaaa","269":"8ebbfaaa","293":"6cd444df","319":"8ebbfaaa","648":"8ebbfaaa","884":"8ebbfaaa"}[chunkId] + ".chunk.css";
};